import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type LWApiPublicSslCertificateHostServersResultRaw } from '@liquidweb-dev/club-sauce/public/ssl/certificate/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SSL_CERTIFICATE_HOST_SERVERS_QUERY_KEY =
	'/ssl/certificate/hostServers';

const useSslCertificateHostServers = (
	options?: UseQueryOptions<
		LWApiPublicSslCertificateHostServersResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SSL_CERTIFICATE_HOST_SERVERS_QUERY_KEY],
		queryFn: () => api.ssl.certificate.apiRaw.hostServers(),
		...options,
	});

export default useSslCertificateHostServers;
